import { useMemo } from "react";
import { Loader2 } from "lucide-react";
import { DataTable } from "@/components/ui/data-table";
import type { StockMovementWithArticle } from "@/hooks/queries/useStockMovements";
import { createStockMovementColumns } from "../stockMovementColumns";
import { StockMovementGrid } from "./StockMovementGrid";

interface StockMovementsTabContentProps {
  movements: StockMovementWithArticle[];
  isMobile: boolean;
  isLoading: boolean;
  onSelect: (movement: StockMovementWithArticle) => void;
}

export function StockMovementsTabContent({
  movements,
  isMobile,
  isLoading,
  onSelect,
}: StockMovementsTabContentProps) {
  const columns = useMemo(() => createStockMovementColumns(onSelect), [onSelect]);

  if (isMobile) {
    if (isLoading) return <Loader2 className="animate-spin text-subtle" size={18} />;
    return <StockMovementGrid movements={movements} onSelect={onSelect} />;
  }

  return (
    <DataTable
      columns={columns}
      data={movements}
      loading={isLoading}
      emptyMessage="Aucun mouvement de stock."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
